import { TransactionStatus } from '../../models/enums'

export const isCorrectEntryState = (data: any) =>
  data?.transaction?.status === TransactionStatus.CONTRACT_SIGNED
